(function () {
  if (window.__OVC_VARIANT_GALLERY_SYNC__) return;
  window.__OVC_VARIANT_GALLERY_SYNC__ = true;

  var IMAGE_SELECTOR = 'img[src], img[data-src], img[data-master], img[srcset], img[data-srcset]';
  var VARIANT_INPUT_SELECTOR = '.f8pr-variant-selection input[type="radio"]';
  var scheduledUpdates = new WeakMap();

  function normalizeUrl(value) {
    if (!value) return '';

    try {
      var url = new URL(value, window.location.href);
      return (url.hostname + url.pathname)
        .replace(/_\d+x\d+(?=\.[a-z0-9]+$)/i, '')
        .replace(/_\d+x(?=\.[a-z0-9]+$)/i, '')
        .replace(/_\{width\}x(?=\.[a-z0-9]+$)/i, '')
        .toLowerCase();
    } catch (error) {
      return String(value)
        .split('?')[0]
        .replace(/_\d+x\d+(?=\.[a-z0-9]+$)/i, '')
        .replace(/_\d+x(?=\.[a-z0-9]+$)/i, '')
        .replace(/_\{width\}x(?=\.[a-z0-9]+$)/i, '')
        .toLowerCase();
    }
  }

  function imageKeyFromElement(image) {
    if (!image) return '';

    var source =
      image.getAttribute('data-master') ||
      image.currentSrc ||
      image.getAttribute('src') ||
      image.getAttribute('data-src') ||
      image.getAttribute('srcset') ||
      image.getAttribute('data-srcset') ||
      '';

    if (source.indexOf(',') > -1) source = source.split(',')[0];
    source = source.trim().split(' ')[0];

    return normalizeUrl(source);
  }

  function selectedVariantImage(container) {
    if (!container) return '';

    var selectedInputs = Array.prototype.slice.call(
      container.querySelectorAll(VARIANT_INPUT_SELECTOR + ':checked')
    );

    for (var i = 0; i < selectedInputs.length; i += 1) {
      var label = selectedInputs[i].closest('label');
      var image = label && label.querySelector(IMAGE_SELECTOR);
      var imageKey = imageKeyFromElement(image);
      if (imageKey) return imageKey;
    }

    return '';
  }

  function findMainGallery(container) {
    if (!container) return null;

    var galleries = Array.prototype.slice.call(
      container.querySelectorAll(
        '.l4pr-container[data-slider], .l4pr-container .swiper-outer > .swiper, .l4pr-container .swiper'
      )
    );

    return (
      galleries.find(function (gallery) {
        return gallery.querySelectorAll(IMAGE_SELECTOR).length > 1;
      }) ||
      galleries[0] ||
      null
    );
  }

  function findGalleryTarget(gallery, imageKey) {
    if (!gallery || !imageKey) return null;

    var images = Array.prototype.slice.call(gallery.querySelectorAll(IMAGE_SELECTOR));
    var image = images.find(function (candidate) {
      return imageKeyFromElement(candidate) === imageKey;
    });

    if (!image) return null;

    var slide = image.closest('.swiper-slide, li, [data-slide], .product-media, figure, .media');
    var slides = Array.prototype.slice.call(
      gallery.querySelectorAll('.swiper-wrapper > .swiper-slide:not(.swiper-slide-duplicate)')
    );

    if (!slides.length) {
      slides = Array.prototype.slice.call(gallery.children).filter(function (child) {
        return child.nodeType === 1;
      });
    }

    var index = slide ? slides.indexOf(slide) : -1;
    if (index < 0) index = images.indexOf(image);

    return {
      image: image,
      slide: slide,
      index: Math.max(0, index)
    };
  }

  function getSwiper(gallery) {
    if (!gallery) return null;
    if (gallery.swiper) return gallery.swiper;

    var nested = gallery.querySelector('.swiper');
    if (nested && nested.swiper) return nested.swiper;

    var wrapper = gallery.closest('.swiper');
    if (wrapper && wrapper.swiper) return wrapper.swiper;

    return null;
  }

  function moveNativeScroller(gallery, target) {
    if (!gallery || !target || !target.slide) return false;

    var candidates = [
      gallery.querySelector('.swiper-wrapper'),
      gallery,
      gallery.closest('.swiper')
    ].filter(Boolean);

    var scroller = candidates.find(function (element) {
      return (
        element.scrollWidth > element.clientWidth + 4 ||
        element.scrollHeight > element.clientHeight + 4
      );
    });

    if (!scroller || typeof scroller.scrollTo !== 'function') return false;

    var options = { behavior: 'smooth' };
    if (scroller.scrollWidth > scroller.clientWidth + 4) {
      options.left = target.slide.offsetLeft;
    } else {
      options.top = target.slide.offsetTop;
    }

    scroller.scrollTo(options);
    return true;
  }

  function updateGallery(container) {
    if (!container || !container.isConnected) return;

    var imageKey = selectedVariantImage(container);
    var gallery = findMainGallery(container);
    var target = findGalleryTarget(gallery, imageKey);

    if (!gallery || !target || !imageKey) return;
    if (gallery.getAttribute('data-ovc-active-variant-image') === imageKey) return;

    var swiper = getSwiper(gallery);
    if (swiper) {
      if (swiper.params && swiper.params.loop && typeof swiper.slideToLoop === 'function') {
        swiper.slideToLoop(target.index, 250);
      } else if (typeof swiper.slideTo === 'function') {
        swiper.slideTo(target.index, 250);
      } else {
        return;
      }

      gallery.setAttribute('data-ovc-active-variant-image', imageKey);
      return;
    }

    if (moveNativeScroller(gallery, target)) {
      gallery.setAttribute('data-ovc-active-variant-image', imageKey);
    }
  }

  function scheduleUpdate(container) {
    if (!container) return;

    var existing = scheduledUpdates.get(container) || [];
    existing.forEach(function (timer) {
      clearTimeout(timer);
    });

    var timers = [0, 100, 250, 500, 900, 1400].map(function (delay) {
      return setTimeout(function () {
        updateGallery(container);
      }, delay);
    });

    scheduledUpdates.set(container, timers);
  }

  function imageSwatchLabelFromTarget(target) {
    if (!target || !target.closest) return null;

    var label = target.closest('.f8pr-variant-selection label');
    if (!label || !label.querySelector('input[type="radio"]')) return null;
    if (!label.querySelector(IMAGE_SELECTOR)) return null;

    return label;
  }

  document.addEventListener('click', function (event) {
    var label = imageSwatchLabelFromTarget(event.target);
    if (!label) return;

    scheduleUpdate(label.closest('.m6pr'));
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches(VARIANT_INPUT_SELECTOR)) return;

    var label = event.target.closest('label');
    if (!label || !label.querySelector(IMAGE_SELECTOR)) return;

    scheduleUpdate(event.target.closest('.m6pr'));
  });

  document.addEventListener('theme:variant:updated', function (event) {
    var container = event.target && event.target.closest ? event.target.closest('.m6pr') : null;
    if (!container) container = document.querySelector('.m6pr');
    scheduleUpdate(container);
  });
})();
